import {get, post} from "@/config/api";

const state = {
  addressList: []
};

const getters = {
  addressList: state => {
    return state.addressList
  }
};

const mutations = {
  SetAddressList (state, payload) {
    state.addressList = payload;
  }
};

const actions = {
  UpdateUserAddress({}, params) {
    return new Promise((resolve, reject) => {
      post("account/update_address/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
